<template>
    <Popover v-slot="{ open, close }" class="relative" ref="popoverRef">
        <PopoverButton
            class="flex items-center lg:w-full hover:text-primary justify-center space-x-1 focus:outline-none outline-transparent ring-none rounded-md focus-visible:ring-0 focus-visible:ring-white/75"
            :class="[
                fit ? 'w-fit' : 'lg:w-full',
                dapp &&
                    'rounded-md justify-center px-2 py-1 lg:border-gray-200 lg:border items-center cursor-pointer lg:hover:bg-gray-200 transition-all duration-300',
                ,
                dapp ? 'text-black' : 'text-white',
                bold ? 'font-bold' : 'font-medium',
                ' transition-all duration-300',
            ]"
            @click="handleLanguagePopoverClick(open)"
        >
            <span v-if="!reverse" class="mt-0.5 text-xl">{{ currentLocaleFlag }}</span>

            <span v-if="reverse" class="mt-0.5">{{ currentLocaleFlag }}</span>
        </PopoverButton>
        <transition
            enter-active-class="transition duration-200 ease-out"
            enter-from-class="translate-y-1 opacity-0"
            enter-to-class="translate-y-0 opacity-100"
            leave-active-class="transition duration-150 ease-in"
            leave-from-class="translate-y-0 opacity-100"
            leave-to-class="translate-y-1 opacity-0"
        >
            <PopoverPanel
                v-if="open"
                :class="[dapp ? 'bg-white' : 'bg-black/70', right ? 'left-auto right-0' : 'left-0']"
                class="absolute top-full font-bold lg:left-auto lg:right-0 space-y-2 mt-4 rounded-md p-2 min-w-[10rem] z-50 shadow-md"
            >
                <button
                    @click="
                        setLanguage('en', () => {
                            close();
                        })
                    "
                    :class="[
                        dapp ? 'text-black' : 'text-white',
                        'flex items-center gap-2 w-full text-left text-base transition-colors duration-200',
                        locale === 'en'
                            ? dapp
                                ? ' !text-primary rounded-md p-2'
                                : ' rounded-full !text-primary p-2'
                            : dapp
                              ? '!text-black hover:bg-gray-100 rounded-md p-2'
                              : 'text-white !hover:text-secondary rounded-full p-2',
                    ]"
                >
                    <span class="text-lg">🇺🇸</span> {{ $t('navbar.english') }}
                </button>
                <button
                    @click="
                        setLanguage('cs', () => {
                            close();
                        })
                    "
                    :class="[
                        dapp ? 'text-black' : 'text-white !hover:text-secondary',
                        'flex items-center gap-2 w-full text-left text-base  transition-colors duration-200',
                        locale === 'cs'
                            ? dapp
                                ? ' !text-primary rounded-md p-2'
                                : '!text-primary p-2'
                            : dapp
                              ? '!text-black hover:bg-gray-100 rounded-md p-2'
                              : 'text-white !hover:text-secondary rounded-full p-2',
                    ]"
                >
                    <span class="text-lg">🇨🇿</span> {{ $t('navbar.czech') }}
                </button>
                <button
                    @click="
                        setLanguage('fr', () => {
                            close();
                        })
                    "
                    :class="[
                        dapp ? 'text-black' : 'text-white !hover:text-secondary',
                        'flex items-center gap-2 w-full text-left text-base  transition-colors duration-200',
                        locale === 'fr'
                            ? dapp
                                ? ' !text-primary rounded-md p-2'
                                : '!text-primary p-2'
                            : dapp
                              ? '!text-black hover:bg-gray-100 rounded-md p-2'
                              : 'text-white !hover:text-secondary rounded-full p-2',
                    ]"
                >
                    <span class="text-lg">🇫🇷</span> {{ $t('navbar.french') }}
                </button>
            </PopoverPanel>
        </transition>
    </Popover>
</template>

<script setup lang="ts">
    import { Popover, PopoverButton, PopoverPanel } from '@headlessui/vue';

    const { t, setLocale } = useI18n();

    const { dapp, bold, reverse } = defineProps({
        fit: Boolean,
        right: Boolean,
        dapp: Boolean,
        bold: Boolean,
        reverse: Boolean,
    });
    const { locale } = useI18n();
    const openPopover = inject('openPopover'); // expected: { value: string }
    const popoverRef = ref();

    const localeLabel = computed(() => {
        /*    if (!dapp) { */
        return locale.value === 'en' ? 'EN' : locale.value === 'cs' ? 'CS' : 'FR';
        /*  }
        return locale.value === 'en'
            ? t('navbar.english')
            : locale.value === 'cs'
              ? t('navbar.czech')
              : t('navbar.french'); */
    });
    const currentLocaleFlag = computed(() => {
        return locale.value === 'en' ? '🇺🇸' : locale.value == 'cs' ? '🇨🇿' : '🇫🇷';
    });

    function handleLanguagePopoverClick(isOpen) {
        if (!isOpen && openPopover) {
            openPopover.value = 'language';
        }
    }

    watch(openPopover, (val) => {
        // If another popover is triggered, close this one
        if (val !== 'language' && popoverRef.value && typeof popoverRef.value.close === 'function') {
            popoverRef.value.close();
        }
    });

    const emits = defineEmits(['closeMenu']);

    function setLanguage(lang: string, callback: () => void) {
        setLocale(lang);
        if (popoverRef.value && typeof popoverRef.value.close === 'function') popoverRef.value.close();

        if (callback) {
            callback();
            emits('closeMenu');
        }
    }
</script>
